import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

const placeholderContainerStyles = css({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	cursor: 'not-allowed !important',
	marginTop: token('space.025', '2px'),
	marginBottom: token('space.025', '2px'),
	marginLeft: '0px',
});

const reactionPillStyles = css({
	width: 42,
	height: 24,
	backgroundColor: token('color.skeleton.subtle', 'rgba(9, 30, 66, 0.04)'),
	borderRadius: 20,
	marginRight: token('space.050', '4px'),
});

const reactionIconStyles = css({
	width: 12,
	height: 12,
	backgroundColor: token('color.skeleton.subtle', 'rgba(9, 30, 66, 0.04)'),
	borderRadius: 20,
	marginLeft: token('space.075', '6px'),
});

const DEFAULT_NUM_PILLS = 2;

export const ReactionsPlaceholder = (): JSX.Element => {
	const renderPlaceholder = (numPills: number) => (
		<div css={placeholderContainerStyles} data-testid="reactions-placeholder">
			{Array(numPills)
				.fill('')
				.map((_, i) => (
					<span css={reactionPillStyles} key={i} data-testid="reactions-pill" />
				))}
			<span css={reactionIconStyles} data-testid="reaction-icon" />
		</div>
	);

	return renderPlaceholder(DEFAULT_NUM_PILLS);
};
